import { Feature } from 'ol';
import { LineString, Point } from 'ol/geom';
import { Stroke, Style } from 'ol/style';
import { calcSpeedKmh, distanceBetween, safeParseTime } from '.';
import { baseLineStyle, fastLineStyle, stopPointStyle } from '../constants';

const STOP_DISTANCE_THRESHOLD = 5; // радиус в метрах, чтобы стоянка считалась неподвижной

const buildFeaturesFromRoutes = (routes, speedLimit, stopTime, color) => {
  const stopSet = new Set();

  // Создаём стили с переданным цветом
  const normalLineStyle = color ? new Style({ stroke: new Stroke({ color, width: 4 }) }) : baseLineStyle;

  const limitExceededLineStyle = color
    ? new Style({ stroke: new Stroke({ color: '#ff0000', width: 4 }) })
    : fastLineStyle;

  return routes.flatMap((route) => {
    if (!route || route.length < 2) return [];

    let stationaryStart = null; // индекс начала серии неподвижных точек
    let stationaryTime = 0; // накопленное время

    return route.slice(1).flatMap((cur, i) => {
      const prev = route[i];
      if (!prev?.coordinates || !cur?.coordinates) return [];

      const features = [];

      const seg = new Feature(new LineString([prev.coordinates, cur.coordinates]));

      // превышения
      if (speedLimit) {
        const speedKmh = calcSpeedKmh(prev, cur);
        seg.setStyle(speedKmh > speedLimit ? limitExceededLineStyle : normalLineStyle);
      } else {
        seg.setStyle(normalLineStyle);
      }
      features.push(seg);

      // стоянки
      if (stopTime) {
        // если есть первая точка серии, то считаем расстояние от нее
        const referencePoint = stationaryStart || prev;

        const dist = distanceBetween(referencePoint.coordinates, cur.coordinates);

        const dtSec = (safeParseTime(cur.date) - safeParseTime(prev.date)) / 1000;

        if (dist <= STOP_DISTANCE_THRESHOLD) {
          if (stationaryStart === null) stationaryStart = prev;
          stationaryTime += dtSec;
        } else {
          stationaryStart = null;
          stationaryTime = 0;
        }

        // Если серия неподвижных точек закончилась, проверяем её длительность
        if (stationaryTime >= stopTime && stationaryStart !== null) {
          const key = `${stationaryStart.coordinates[0]}:${stationaryStart.coordinates[1]}:${Math.round(stationaryTime)}`;
          if (!stopSet.has(key)) {
            stopSet.add(key);
            const pointFeat = new Feature(new Point(stationaryStart.coordinates));
            pointFeat.setStyle(stopPointStyle);
            features.push(pointFeat);
          }
        }
      }

      return features;
    });
  });
};

export default buildFeaturesFromRoutes;
